// frontend/src/components/ui/SWUpdateToast.tsx
import React, { useState, useEffect } from 'react';
import { RefreshCw, X } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Listens for 'sw-update-available' custom event dispatched by serviceWorkerRegistration.ts.
 * Shows a dismissable toast prompting the user to reload for the new version.
 */
export const SWUpdateToast: React.FC = () => {
    const [visible, setVisible] = useState(false);
    const { lang } = useLanguage();

    useEffect(() => {
        const handleUpdate = () => setVisible(true);
        window.addEventListener('sw-update-available', handleUpdate);
        return () => window.removeEventListener('sw-update-available', handleUpdate);
    }, []);

    if (!visible) return null;

    const handleReload = () => {
        setVisible(false);
        window.location.reload();
    };

    return (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[300] animate-in fade-in slide-in-from-bottom-4 duration-300">
            <div className="flex items-center gap-3 px-4 py-3 bg-slate-800/95 text-white text-sm font-medium rounded-xl shadow-2xl backdrop-blur-md border border-slate-600/50 max-w-sm">
                <RefreshCw className="w-4 h-4 text-orange-400 shrink-0 animate-spin" style={{ animationDuration: '3s' }} />
                <span className="flex-1 text-slate-200">
                    {lang === 'tr'
                        ? 'Yeni sürüm mevcut'
                        : 'A new version is available'}
                </span>
                <button
                    onClick={handleReload}
                    className="px-3 py-1 bg-orange-500 hover:bg-orange-400 text-white text-xs font-semibold rounded-lg transition-colors shrink-0"
                >
                    {lang === 'tr' ? 'Güncelle' : 'Update'}
                </button>
                <button
                    onClick={() => setVisible(false)}
                    className="text-slate-400 hover:text-white transition-colors shrink-0"
                    aria-label="Dismiss"
                >
                    <X className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
};

export default SWUpdateToast;
